export default __webpack_public_path__ + "static/media/12-17.f56a7584.png";